import React from 'react';
import DetailedHeader from '../../../../components/ProjectDetailedPageComponents/DetailedHeader';
import ImageSlider from '../../../../components/Misc/ImageSlider';
import Seo from '../../../../components/Misc/Seo';
import projectImage1 from '../../../../assets/images/work/norcat-lock-tag/LOTO_Slider_1.jpg';
import projectImage2 from '../../../../assets/images/work/norcat-lock-tag/LOTO_Slider_2.jpg';
import projectImage3 from '../../../../assets/images/work/norcat-lock-tag/LOTO_Slider_3.jpg';
import projectImage4 from '../../../../assets/images/work/norcat-lock-tag/LOTO_Slider_4.jpg';
import projectImage5 from '../../../../assets/images/work/norcat-lock-tag/LOTO_Slider_5.jpg';
import projectImage6 from '../../../../assets/images/work/norcat-lock-tag/LOTO_Slider_6.jpg';

import Data_norcatLockTag from './Data_NORCATLockTag';

function Work_norcatLockTag() {
    const canonical = 'https://studio.norcat.org/OurWork/norcat-lock-tag';
    const title = 'NORCAT Lock and Tag | Studio NORCAT - Driven by experiences that matter.';
    const description = "Developed by Studio NORCAT, the NORCAT Lock and Tag Program uses scenario-based virtual reality training to build confidence, reinforce safe habits, and support repeatable lockout and tagout procedures in workplace settings.";

    return (
        <>
            <Seo
                title={title}
                description={description}
                canonical={canonical}
                ogTitle={title}
                ogDescription={description}
                ogImage={`${window.location.origin}${projectImage1}`}
                ogImageAlt="Preview of the NORCAT Lock and Tag VR training project"
                twitterTitle={title}
                twitterDescription={description}
                twitterImage={`${window.location.origin}${projectImage1}`}
                twitterImageAlt="Preview of the NORCAT Lock and Tag VR training project"
            />
            <DetailedHeader
                heading="Where Lockout Procedures Become Second Nature"
                client="NORCAT"
                service="Virtual Reality"
                date="2026"
            />
            <ImageSlider
                noArt="true"
                swiperNav="true"
                useButtonNav="true"
                youtubeUrl="https://www.youtube.com/watch?v=lD-et4T-N0c"
                images={[
                    {
                        image: projectImage1,
                        alt: 'NORCAT Lock and Tag project screenshot 1',
                    },
                    {
                        image: projectImage2,
                        alt: 'NORCAT Lock and Tag project screenshot 2',
                    },
                    {
                        image: projectImage3,
                        alt: 'NORCAT Lock and Tag project screenshot 3',
                    },
                    {
                        image: projectImage4,
                        alt: 'NORCAT Lock and Tag project screenshot 4',
                    },
                    {
                        image: projectImage5,
                        alt: 'NORCAT Lock and Tag project screenshot 5',
                    },
                    {
                        image: projectImage6,
                        alt: 'NORCAT Lock and Tag project screenshot 6',
                    },
                ]}
            />

            {Data_norcatLockTag.content}
        </>
    );
}

export default Work_norcatLockTag;
